import { Action } from "..";

export const EMAIL_CHANGE = "EMAIL_CHANGE";
export const HASH_CHANGE = "HASH_CHANGE";
export const TYPE_CHANGE = "TYPE_CHANGE";

export function setEmail(email: string | null): Action {
  return { type: EMAIL_CHANGE, payload: email };
}

export function setHash(hash: string | null): Action {
  return { type: HASH_CHANGE, payload: hash };
}

export function setType(type: string | null): Action {
  return { type: TYPE_CHANGE, payload: type };
}
